import type { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { AragModal } from '../aragModal/AragModal';
import MietrechtsschutzJpg from './images/rent_legal.png';
import MietrechtsschutzWebp from './images/rent_legal.webp';
import MietrechtsschutzMobileJpg from './images/rent_legal_mobile.png';
import MietrechtsschutzMobileWebp from './images/rent_legal_mobile.webp';
import PhonePng from './images/phone.png';
import PhoneWebp from './images/phone.webp';
import Section3Png from './images/section3.png';
import Section3Webp from './images/section3.webp';
import { InsuranceServiceName } from '@/@types/insurance';

export const Mietrechtsschutz = ({ isVisible, onClose }: BenefitModalProps) => {
  return (
    <AragModal
      serviceName={InsuranceServiceName.MIETRECHTSSCHUTZ}
      image={MietrechtsschutzJpg}
      imageWebp={MietrechtsschutzWebp}
      imageMobile={MietrechtsschutzMobileJpg}
      imageMobileWebp={MietrechtsschutzMobileWebp}
      howItWorksImage1Png={PhonePng}
      howItWorksImage1WebP={PhoneWebp}
      howItWorksImage2Png={Section3Png}
      howItWorksImage2WebP={Section3Webp}
      isVisible={isVisible}
      onClose={onClose}
      additionalParagraph={true}
    />
  );
};
export default Mietrechtsschutz;
